/** A mono PCM16 WAV file (44-byte RIFF header + samples, little-endian). */
export const pcm16ToWav = (pcm: Int16Array, sampleRate: number): Blob => {
  const header = new DataView(new ArrayBuffer(44));
  const text = (offset: number, value: string): void => {
    for (let i = 0; i < value.length; i++)
      header.setUint8(offset + i, value.charCodeAt(i));
  };
  const dataBytes = pcm.length * 2;
  text(0, "RIFF");
  header.setUint32(4, 36 + dataBytes, true);
  text(8, "WAVE");
  text(12, "fmt ");
  header.setUint32(16, 16, true);
  header.setUint16(20, 1, true); // PCM
  header.setUint16(22, 1, true); // mono
  header.setUint32(24, sampleRate, true);
  header.setUint32(28, sampleRate * 2, true);
  header.setUint16(32, 2, true);
  header.setUint16(34, 16, true);
  text(36, "data");
  header.setUint32(40, dataBytes, true);
  const body = new Int16Array(pcm.length);
  const view = new DataView(body.buffer);
  for (let i = 0; i < pcm.length; i++)
    view.setInt16(i * 2, pcm[i] as number, true);
  return new Blob([header.buffer, body.buffer], { type: "audio/wav" });
};
